const ServiceIDs = { DataDog: 'P7XVa18qr', DataDogRUM: 'Xl0HIOViY' };
export const isConsentGiven = (serviceName) => {
    try {
        const serviceID = ServiceIDs[serviceName];
        const userCentricsSettings = localStorage.getItem('uc_settings');
        const parsedSettings = userCentricsSettings
            ? JSON.parse(userCentricsSettings)
            : { services: [] };
        const service = parsedSettings.services.find((item) => (item === null || item === void 0 ? void 0 : item.id) === serviceID);
        return service ? !!service.status : false;
    }
    catch (error) {
        console.error(`Error retrieving ${serviceName} service status:`, error);
        return false;
    }
};
//# sourceMappingURL=consent.js.map